module.exports = __webpack_public_path__ + "img/4.271eaac4.jpg";